import React, { useRef } from 'react'
import IconClose from '../../assets/icons/IconClose'
import IconCheck from '../../assets/icons/IconCheck'
import IconRefresh from '../../assets/icons/IconRefresh'
import FormatCurrency from '../elements/FormatCurrency'
import DynamicColor from '../common/dynamic-color'

import { COLOR_NAME, MODAL_KEYS } from '../../constants'
import { reMapBeilage, getFoodPriceShow, getDisplayFoodName } from '../../utils'
import useMoney from '../../hooks/useMoney'
import useModal from '../../hooks/useModal'
import GroupAmountSmall from '../elements/group-amount-small'
import useDidMountEffect from '../../hooks/useDidMountEffect'
import { setPrinterSelectData } from '../../actions/orderActions'
import { useDispatch } from 'react-redux'

const ICON_STATE = [IconRefresh, IconCheck]

const FoodItemAdded = ({
    item = {},
    index,
    handleUpdateAmount,
    setFoodSelected,
    orderState,
    viewOnly,
}) => {
    const { foodDetails, amount } = item;
    const foodRef = useRef();
    const { toggleModal } = useModal(MODAL_KEYS.tableQrcodePrinter);
    const dispatch = useDispatch();

    const { currentPrice, originPrice } = useMoney(
        getFoodPriceShow,
        foodDetails
    )

    useDidMountEffect(() => {
        // const className = `food-add-ani-${amount}`
        const className = 'food-add-ani'
        foodRef.current.classList.add(className)
        const timeOut = setTimeout(() => {
            foodRef.current && foodRef.current.classList.remove(className)
        }, 400)

        return () => {
            timeOut && clearTimeout(timeOut)
            foodRef.current && foodRef.current.classList.remove(className)
        }
    }, [amount])

    if (!foodDetails) {
        return null
    }

    // map list id topping to get full info for show
    let toppingShow = reMapBeilage(item)

    let iconShow = IconClose
    if (orderState !== undefined) {
        iconShow = ICON_STATE[orderState]
    }

    const handleShowSelectPrinter = e => {
        e.stopPropagation();
        toggleModal(true);
        dispatch(setPrinterSelectData(item));
    }

    return (
        <DynamicColor
            style={{ borderColor: COLOR_NAME.BODY_LINE }}
            className="food-item-added-wrap"
            ref={foodRef}
        >
            <div
                className="food-item-added"
                onClick={() => !viewOnly && setFoodSelected({ ...item, index })}
            >
                <DynamicColor
                    style={{ color: COLOR_NAME.BODY_TEXT }}
                    className="food-item-added__main"
                >
                    <div className="food-info">
                        <div className="food-info--name">
                            {getDisplayFoodName(foodDetails)}
                        </div>

                        <GroupAmountSmall
                            handleUpdateAmount={amount =>
                                handleUpdateAmount(
                                    amount,
                                    foodDetails?.id,
                                    item.groupOrder,
                                    index
                                )
                            }
                            amount={amount}
                        />

                        <div className="price">
                            <div>
                                <FormatCurrency
                                    amount={currentPrice * amount}
                                />
                            </div>
                            {!!originPrice && (
                                <div className="price--old label-3">
                                    <FormatCurrency
                                        amount={originPrice * amount}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    {(!!item.note || !!toppingShow?.length) && (
                        <div className="list-topping">
                            {!!item.note && (
                                <div className="list-topping__item label-3">
                                    <div>{item.note}</div>
                                    <div />
                                </div>
                            )}

                            {toppingShow.map((el, i) => (
                                <DynamicColor
                                    style={{ color: COLOR_NAME.BODY_TEXT_SUB }}
                                    key={i}
                                    className="list-topping__item label-3"
                                >
                                    <div>{el.name_food}</div>
                                    {!!el.price && (
                                        <div className="price">
                                            <FormatCurrency
                                                amount={el.price * amount}
                                            />
                                        </div>
                                    )}
                                </DynamicColor>
                            ))}
                        </div>
                    )}
                    {item?.printerSelected && <div onClick={handleShowSelectPrinter} className="printer-selected">{item?.printerSelected?.name}</div>}
                </DynamicColor>
            </div>
        </DynamicColor>
    )
}

export default FoodItemAdded
